/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ahu_History_Key_Missmatchdefect1Inputs */



/**
* | output |
* | --- |
* | "Mismatch fault" |
*
* @param {Ahu_History_Key_Missmatchdefect1Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const ahu_history_key_missmatchdefect1 = /** @type {((inputs?: Ahu_History_Key_Missmatchdefect1Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ahu_History_Key_Missmatchdefect1Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Mismatch fault")
	return /** @type {LocalizedString} */ ("Défaut de discordance")
});
export { ahu_history_key_missmatchdefect1 as "ahu_history_key_missmatchDefect" }